import copy from 'copy-to-clipboard'

export default function copyText(...params: Parameters<typeof copy>): boolean {
  const [text, options = {}] = params

  const message = options?.message ?? 'Нажмите #{key} для копирования'

  return copy(text, {
    ...options,
    message,
  })
}
